
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.012 4.75A7.227 7.227 0 007.8 6.095a.734.734 0 01-1.031-.182.756.756 0 01.18-1.045 8.694 8.694 0 015.063-1.618c4.817 0 8.738 3.908 8.738 8.75 0 4.842-3.921 8.75-8.738 8.75S3.273 16.842 3.273 12c0-.845.12-1.664.344-2.438l-.592.25a.737.737 0 01-.968-.403.754.754 0 01.398-.981l2.295-.97a.737.737 0 01.965.397l.97 2.295a.754.754 0 01-.39.985.736.736 0 01-.971-.395l-.3-.709a7.254 7.254 0 006.988 9.219A7.254 7.254 0 0019.27 12c0-3.995-3.24-7.25-7.258-7.25zm.008 1.744c.41 0 .74.336.74.75v4.381l1.488 1.488c.29.29.294.766.007 1.06a.733.733 0 01-1.047.007l-1.707-1.708a.755.755 0 01-.22-.533V7.244c0-.414.33-.75.74-.75z","fill":"#202D38"}})])
          )
        }
      }
    